export default __webpack_public_path__ + "12037feed4cde77f86d8b8dfab96710d.png";